import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Clock } from "lucide-react";
import { Layout } from "../components/Layout";
import { useI18n } from "../i18n";
import { eur } from "../lib/format";
import * as apiClient from "../api";

export default function Tomorrow() {
  const { t } = useI18n();
  const { data: tomorrow = [], isLoading } = useQuery({ queryKey: ["tomorrow"], queryFn: apiClient.getTomorrow });

  return (
    <Layout>
      <div className="bg-gradient-to-b from-slate-50 to-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-secondary mb-2">Domani a Vieste</div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-semibold tracking-tight text-slate-900">{t("home.tomorrow")}</h1>
          <p className="text-slate-500 mt-2">{t("home.tomorrow.sub")}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        {isLoading ? <div className="text-center py-20 text-slate-400">{t("common.loading")}</div> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {tomorrow.map((e) => (
              <Link key={e.id} to={`/esperienza/${e.slug}`} data-testid={`tomorrow-item-${e.slug}`} className="bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm hover-lift">
                <div className="relative h-40 overflow-hidden">
                  <img src={e.image} alt={e.title} className="h-full w-full object-cover img-zoom" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-2 left-3 right-3 text-white font-heading font-semibold text-sm line-clamp-2 drop-shadow">{e.title}</div>
                </div>
                <div className="p-4 space-y-1.5">
                  {e.slots.slice(0, 4).map((s) => (
                    <div key={s.time} className="flex items-center justify-between text-sm">
                      <span className="flex items-center gap-1.5 text-slate-700 font-medium"><Clock className="h-3.5 w-3.5 text-primary" />{s.time}</span>
                      <span className={`text-xs font-semibold ${s.status === "few" ? "text-accent" : s.status === "full" ? "text-slate-300" : "text-emerald-600"}`}>
                        {s.status === "few" ? `${t("exp.few")} (${s.available})` : s.status === "full" ? t("exp.full") : t("exp.available")}
                      </span>
                    </div>
                  ))}
                  <div className="pt-2 flex items-center justify-between border-t border-slate-50">
                    <span className="text-xs text-slate-400">{e.operator_name}</span>
                    <span className="font-bold text-primary">{eur(e.price)}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
